/**
 *
 * A component to add custom html to a page.
 *
 * > **💡 NOTE**: scripts inside the html will be inserted into the head of the document and executable.
 *
 * > **⚠️ CAUTION:** Always ensure you trust the source of included scripts.
 * >
 * > Note also that externally sourced html with scripts may be updated by the original author at any point unbeknownst to you,
 * > therefore it is highly important that the html source is trustworthy.
 *
 *
 * Usage example:
 *
 * ```javascript
 * export const MyCustomComponent: React.FC = () => {
 *   const html: string = `
 *     <script>
 *       console.log('This is my custom HTML page');
 *     </script>
 *     <section>
 *       Custom HTML content
 *     </section>
 *   `;
 *
 *   return (
 *     <div>
 *       Here is my custom HTML:
 *       <InnerHtml html={html} />
 *     </div>
 *   );
 * };
 * ```
 */
import React, { useRef } from 'react';
import { useInjectCustomHTML } from '../hooksInternal/useInjectCustomHTML';
const InnerHtml = (props) => {
    const { html, ...rest } = props;
    const containerRef = useRef(null);
    useInjectCustomHTML({ html, containerRef });
    return React.createElement("div", { ...rest, ref: containerRef });
};
InnerHtml.displayName = 'InnerHtml';
/**
 * # InnerHtml
 */
export default InnerHtml;
//# sourceMappingURL=InnerHtml.js.map